// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3MHCz","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2ezX6"};